import DefaultLoader from './default-loader';

export default DefaultLoader;
